import { useTranslation } from 'react-i18next';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { AddressUseForm } from './use-address-form';

type Props = {
  form: AddressUseForm;
};

const AddressForm = ({ form }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="grid gap-2">
      <span className="font-medium text-sm leading-none">
        {t('add-office-form.address.label')}
      </span>

      <div className="grid gap-4 sm:grid-cols-2">
        <FormField
          control={form.control}
          name="address.line1"
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t('add-office-form.address.line1.label')}</FormLabel>
              <FormControl>
                <Input
                  type="text"
                  placeholder={t('add-office-form.address.line1.placeholder')}
                  {...field}
                />
              </FormControl>

              <FormMessage />
            </FormItem>
          )}
        ></FormField>

        <FormField
          control={form.control}
          name="address.line2"
          render={({ field }) => (
            <FormItem className="sm:col-span-2">
              <FormLabel>{t('add-office-form.address.line2.label')}</FormLabel>
              <FormControl>
                <Input
                  type="text"
                  placeholder={t('add-office-form.address.line2.placeholder')}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        ></FormField>

        <FormField
          control={form.control}
          name="address.postalCode"
          render={({ field }) => (
            <FormItem>
              <FormLabel>
                {t('add-office-form.address.postal-code.label')}
              </FormLabel>
              <FormControl>
                <Input
                  type="text"
                  placeholder={t(
                    'add-office-form.address.postal-code.placeholder',
                  )}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        ></FormField>
        <FormField
          control={form.control}
          name="address.city"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t('add-office-form.address.city.label')}</FormLabel>
              <FormControl>
                <Input
                  type="text"
                  placeholder={t('add-office-form.address.city.placeholder')}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        ></FormField>
      </div>
    </div>
  );
};

export default AddressForm;
